import {S21CsaAsccComponent} from "./S21CsaAsccComponent";


export function S21CsaAsccScreen() {
  return (<>
    <S21CsaAsccComponent/>
  </>)
}
